/* =========================================================
   ULTIMATE WORKWEAR — TRADE LANDING PAGE
   Sticky-CTA reveal, scroll-reveal, FAQ accordion, smooth-scroll.
   Wrapped in an IIFE so it doesn't pollute the theme's globals.
   The original page-internal <nav> is stripped (theme has its own),
   so the nav-scroll-state code is removed.
   ========================================================= */
(function () {
  'use strict';

  /* ---------- Sticky CTA reveal after scrolling past hero ---------- */
  var sticky = document.getElementById('stickyCta');

  function onScroll() {
    if (sticky) sticky.classList.toggle('show', window.scrollY > 700);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Scroll-reveal via IntersectionObserver ---------- */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    // Fallback: just show everything immediately
    reveals.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var btn = item.querySelector('.faq-question');
    var ans = item.querySelector('.faq-answer');
    if (!btn || !ans) return;
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('open');
      // Close all
      document.querySelectorAll('.faq-item.open').forEach(function (o) {
        o.classList.remove('open');
        var oa = o.querySelector('.faq-answer');
        if (oa) oa.style.maxHeight = '0px';
      });
      if (!isOpen) {
        item.classList.add('open');
        ans.style.maxHeight = ans.scrollHeight + 'px';
      }
    });
  });

  /* ---------- Promo video: try unmuted autoplay, fall back to muted + unmute button ---------- */
  var video = document.querySelector('.video-element');
  var unmuteBtn = document.querySelector('.video-unmute');
  if (video) {
    // Try to autoplay with sound on (works for repeat visitors / sites with media engagement)
    video.muted = false;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        // Browser blocked unmuted autoplay (most fresh visitors). Fall back to muted autoplay
        // and show the "Tap for sound" pill so one click gives them audio.
        video.muted = true;
        var retry = video.play();
        if (retry && typeof retry.catch === 'function') retry.catch(function () { /* give up */ });
        if (unmuteBtn) unmuteBtn.hidden = false;
      });
    }
    if (unmuteBtn) {
      unmuteBtn.addEventListener('click', function () {
        video.muted = false;
        video.play();
        unmuteBtn.hidden = true;
      });
      // If the user unmutes via the native controls, hide our button too
      video.addEventListener('volumechange', function () {
        if (!video.muted) unmuteBtn.hidden = true;
      });
    }
  }

  /* ---------- Smooth-scroll for in-page anchors only ---------- */
  /* Scoped to anchors that target IDs within this landing page,
     so theme nav/dropdown anchors aren't affected. */
  var landingAnchors = ['#book', '#how', '#features', '#faq', '#problem', '#top'];
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    var id = a.getAttribute('href');
    if (!id || id.length < 2) return;
    if (landingAnchors.indexOf(id) === -1) return;
    a.addEventListener('click', function (ev) {
      var el = document.querySelector(id);
      if (!el) return;
      ev.preventDefault();
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();
